import validate from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@24.10.8_db0@0.3.2_eslint@9.38.0_jiti@2.6._36c4871e9ee6960990c90244cd6bbe8e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@24.10.8_db0@0.3.2_eslint@9.38.0_jiti@2.6._36c4871e9ee6960990c90244cd6bbe8e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}